import { render, staticRenderFns } from "./ParticipantData.vue?vue&type=template&id=629ec8fa&"
import script from "./ParticipantData.vue?vue&type=script&lang=js&"
export * from "./ParticipantData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports